const PAYMENT = "/payment";

//App Routes
export const ROUTES = {
  PAYMENT_CONFIRMATION: PAYMENT + "/confirmation/:id",
  PAYMENT_SUCCESS: PAYMENT + "/success",
  PAYMENT_FAILURE: PAYMENT + "/error",
  PAYMENT_CANCEL: PAYMENT + "/cancel",
};



// WEBPACK FOOTER //
// ./src/constants/routeConstants.js